import { useSelector } from "react-redux";
import useClientContext from "../../../../contexts/useClientContext";
import useClientPageTitle from "../../../../contexts/useClientPageTitle";
import { workspaceInvestorSelector } from "../../../../store/state/user/selectors";
import SettingsWrapper from "../SettingsWrapper";
import BankAccounts from "./BankAccounts";
import { isFundInvestorEligibleForBankSelfService } from "./fundAssignmentsHelper";

const BankSettings = () => {
  useClientPageTitle("Bank Accounts");

  const { isFeatureEnabled } = useClientContext();
  const workspaceInvestor = useSelector(workspaceInvestorSelector);

  const canUserEdit = isFeatureEnabled("BankAccountsDetailsEditor");

  return (
    <SettingsWrapper title="Bank Accounts" subtitle={workspaceInvestor?.investorTitle} scrollOwner="children">
      {workspaceInvestor && (
        <BankAccounts
          canUserEdit={canUserEdit}
          investorId={workspaceInvestor.investorId}
          fundInvestors={workspaceInvestor.fundInvestors.filter(isFundInvestorEligibleForBankSelfService)}
        />
      )}
    </SettingsWrapper>
  );
};

export default BankSettings;
